/*
 * Where: src/constants/howToUseContent.js
 * What: Static content for the how-to-use page.
 * Why: Keep operation guidance data-driven and reusable.
 */

export const HOW_TO_USE_HERO = {
    badge: '使い方',
    title: '自宅での確認手順',
    description:
        'このページでは、個人が自宅で本サービスを使う手順を説明します。' +
        ' 本サービスは受給候補の確認のみを対象とし、申請処理は実施しません。',
};

export const HOW_TO_USE_STEPS = [
    {
        id: '01',
        title: '拡張機能とHost設定',
        detail:
            'ChromeへNFC Bridge拡張機能を読み込み、Native Host設定を完了します。',
    },
    {
        id: '02',
        title: '接続確認',
        detail: 'USB NFC4リーダーをPCへ接続し、認識状態を確認します。',
    },
    {
        id: '03',
        title: 'カード読み取り',
        detail: 'マイナンバーカード（Type-B）をかざし、読み取り完了まで待機します。',
    },
    {
        id: '04',
        title: '候補サービス確認',
        detail: '画面に表示された受給候補の内容と条件を確認します。',
    },
    {
        id: '05',
        title: '必要情報のメモ',
        detail: '申請は別手続きのため、候補情報を控えて次の行動を判断します。',
    },
];
